export default __webpack_public_path__ + "static/bsfi-swipe-to-install-dbe7d675fd42aef85b8c2b1a696b2355.gif";